(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aartaa-bespoke-page"]) return;
  try {
    
  document.querySelectorAll('.aartaa-bespoke [data-bespoke-result]').forEach((result) => result.focus());

  } catch(e) { console.error(e); }
})();
})();
